import { Typography, Box, Stack } from "@mui/material";
import MzButton from "@markaaz/ui/MzButton";
import MzAlert from "@markaaz/ui/MzAlert";
import Panel from "./Panel";
import MatchConfiguration from "./configurations/MatchConfiguration";
import MonitoringConfiguration from "./configurations/MonitoringConfiguration";
import PortfolioConfiguration from "./configurations/PortfolioConfiguration";
import FilePlacementConfiguration from "./configurations/FilePlacementConfiguration";
import FileRetrievalConfiguration from "./configurations/FileRetrievalConfiguration";

const sx = {
  header: {
    color: "darkBlue.c100"
  },
  description: {
    color: "darkBlue.c100",
    width: "640px",
    paddingTop: "10px"
  },
  caution: {
    color: "negative.c100"
  }
};

export default function BatchSettings({
  permissions,
  inputFolder,
  outputFolder,
  checkBoxValues,
  portfolios,
  batchRetrieval,
  batchPlacement,
  selectedPortfolio,
  loading,
  showAlert,
  showNotification,
  isPartnerChanged,
  folderError,
  onDisabledSection,
  onAlertClose,
  onCheckBoxChange,
  onBatchRetrieval,
  onBatchPlacement,
  onPortfolioChange,
  onInputFolder,
  onOutputFolder,
  onUpdate
}) {
  return (
    <Box>
      <Box sx={{ marginTop: "80px" }}>
        <Typography variant="h6" sx={sx.header}>
          Batch Configuration
        </Typography>
        <Typography variant="body2" sx={sx.description}>
          Set up parameters for all batch jobs. &nbsp;
          <Typography variant="body2M" sx={sx.caution}>
            Please save changes before leaving the page.
          </Typography>
        </Typography>
      </Box>
      <Box sx={{ marginTop: "40px", marginBottom: "40px" }}>
        <Panel title="Batch Configuration Settings">
          <MatchConfiguration
            showAlert={showAlert}
            checkBoxValues={checkBoxValues}
            permissions={permissions}
            onCheckBoxChange={onCheckBoxChange}
            onDisabledSection={onDisabledSection}
            onAlertClose={onAlertClose}
          />
          <PortfolioConfiguration
            portfolios={portfolios}
            selectedPortfolio={selectedPortfolio}
            checkBoxValues={checkBoxValues}
            permissions={permissions}
            onPortfolioChange={onPortfolioChange}
            onCheckBoxChange={onCheckBoxChange}
          />
          <MonitoringConfiguration
            showAlert={showAlert}
            checkBoxValues={checkBoxValues}
            permissions={permissions}
            onCheckBoxChange={onCheckBoxChange}
            onDisabledSection={onDisabledSection}
            onAlertClose={onAlertClose}
          />
          <FileRetrievalConfiguration
            showAlert={showAlert}
            inputFolder={inputFolder}
            folderError={folderError}
            permissions={permissions}
            batchRetrieval={batchRetrieval}
            onInputFolder={onInputFolder}
            onDisabledSection={onDisabledSection}
            onBatchRetrieval={onBatchRetrieval}
            onAlertClose={onAlertClose}
          />
          <FilePlacementConfiguration
            outputFolder={outputFolder}
            showAlert={showAlert}
            folderError={folderError}
            permissions={permissions}
            batchPlacement={batchPlacement}
            onOutputFolder={onOutputFolder}
            onDisabledSection={onDisabledSection}
            onBatchPlacement={onBatchPlacement}
            onAlertClose={onAlertClose}
          />
        </Panel>
      </Box>
      <Stack direction="row" gap={10} alignItems="center">
        <MzButton variant="contained" size="large" loading={loading} onClick={onUpdate} disabled={isPartnerChanged}>
          Save Configuration
        </MzButton>
        {showNotification.message && (
          <MzAlert
            sx={{ alignItems: "center" }}
            severity={showNotification.type === "success" ? "success" : "error"}
            onClose={() => {
              onAlertClose("saveConfig");
            }}
          >
            {showNotification.message}
          </MzAlert>
        )}
      </Stack>
    </Box>
  );
}
